module.exports = {
	"pagination": {}
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/aws-sdk/apis/firehose-2015-08-04.paginators.json
// module id = 1627
// module chunks = 4